import { FunctionComponent, memo } from 'react';

import classNames from 'classnames';
import classes from './Radio.module.scss';

export enum RadioLabelSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface RadioProps {
  label: string;
  checked: boolean;
  name: string;
  onChange: () => void;
  labelSize?: RadioLabelSizes;
  disabled?: boolean;
  className?: string;
}

export const Radio: FunctionComponent<RadioProps> = memo(
  ({ label, checked, name, onChange, labelSize = RadioLabelSizes.medium, disabled, className }) => {
    return (
      <label
        className={classNames(classes['radio'], classes[`radio--${labelSize}`], className, {
          [classes['radio--checked']]: checked,
          [classes['radio--disabled']]: disabled,
        })}
      >
        <input
          type={'radio'}
          className={classes['radio__input']}
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        {label}
      </label>
    );
  }
);

interface RadioIndicatorProps {
  label: string;
  checked: boolean;
  className?: string;
}

export const RadioIndicator: FunctionComponent<RadioIndicatorProps> = memo(
  ({ label, checked, className }) => {
    return (
      <span
        className={classNames(classes['radio'], classes['radio--medium'], className, {
          [classes['radio--checked']]: checked,
        })}
      >
        {label}
      </span>
    );
  }
);
